module.exports = __webpack_public_path__ + "img/lost-teddy.60f7e1e3.jpg";